/**
 * DEL-770: keeps the variant-level preorder badge (snippets/preorder-variant-badge.liquid)
 * in sync with the selected variant on both the PDP and product-grid cards.
 *
 * Eurus's own variant picker (assets/variant-select.js) already dispatches a single global
 * `eurus:variant:change` CustomEvent (detail.variant = the newly selected variant) whenever
 * a shopper changes options, whether that happens on the product page or on a card in a
 * collection/grid. Since variant ids are unique storefront-wide, we can safely scan every
 * `.x-preorder-variant-badge` instance on the page for a matching `.preorder-variant-meta`
 * child on each event - only the badge belonging to the product whose variant just changed
 * will ever find a match.
 */
if (!window.Eurus.loadedScript.has('preorder-variant-badge.js')) {
  window.Eurus.loadedScript.add('preorder-variant-badge.js');

  requestAnimationFrame(() => {
    function updatePreorderBadge(badgeEl, variantId) {
      const meta = badgeEl.querySelector('.preorder-variant-meta[data-vid="' + variantId + '"]');
      const content = badgeEl.querySelector('.preorder-badge-content');
      if (!content) return;

      const text = meta ? meta.getAttribute('data-text') : '';
      if (text) {
        content.textContent = text;
        content.style.color = meta.getAttribute('data-color') || '';
        content.style.backgroundColor = meta.getAttribute('data-bgcolor') || '';
        badgeEl.classList.remove('hidden');
      } else {
        content.textContent = '';
        content.removeAttribute('style');
        badgeEl.classList.add('hidden');
      }
    }

    document.addEventListener('eurus:variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;

      document.querySelectorAll('.x-preorder-variant-badge').forEach((badgeEl) => {
        if (badgeEl.querySelector('.preorder-variant-meta[data-vid="' + variant.id + '"]')) {
          updatePreorderBadge(badgeEl, variant.id);
        }
      });
    });
  });
}
